import React, { useState } from "react"
import { Form, Row, Card, Input, Button } from "antd"
import { useHistory } from "react-router-dom"
import request from "lib/request"
import { endpoints } from "config/endpoints.config"
import toast from "lib/toast"
import TextArea from "antd/lib/input/TextArea"
import copy from "copy-to-clipboard"
import { WHATSAPP_CLOUD_API_WEBHOOK } from "lib/constants"
import EditEntityCustomFields from "pages/crm/contacts/EditEntityCustomFields"
import FormModal from "components-old/forms/FormModal"
import { channelsDef } from "../channels.def"
import StarAlert from "../StarAlert"

function AddWhatsappCloud() {
  const [form] = Form.useForm()
  const history = useHistory()

  const onSubmit = (model: any) => {
    request.post(endpoints.WHATSAPP_WBA_CLOUD, model).then(() => {
      history.push("/settings/channels")
    })
  }

  const content = (
    <>
      <div className="grid grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))] gap-4">
        <Form.Item
          label="Descrição"
          name="description"
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input placeholder="Canal de suporte" />
        </Form.Item>
        <Form.Item
          label="Identificação do número de telefone"
          name="identifier"
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="ID da conta comercial do WhatsApp"
          name="waba_id"
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Webhook"
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input
            value={WHATSAPP_CLOUD_API_WEBHOOK}
            disabled
            suffix={
              <Button
                icon={<i className="fal fa-copy" />}
                type="text"
                onClick={() => {
                  copy(WHATSAPP_CLOUD_API_WEBHOOK)
                  toast.success("Copiado.")
                }}
              />
            }
          />
        </Form.Item>
        {/* <Form.Item
                        label="Configurações de Encaminhamento"
                        name="identifier"
                        help="Para receber as mensagens que seus clientes enviam para seu e-mail existente, vá para as configurações do seu provedor de email e habilite encaminhamento (forwarding) de todas as mensagens para o endereço especial acima."
                    >
                        <Input disabled />
                    </Form.Item> */}
        <EditEntityCustomFields form={form} entity="channel" />
      </div>
      <Form.Item
        label="Token"
        name="hashIdentifier"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <TextArea rows={5} style={{ minHeight: 120, resize: "none" }} />
      </Form.Item>
    </>
  )

  // if (isAldeia) {
  return (
    <FormModal
      form={form}
      onSubmit={onSubmit}
      onBack={() => history.push("/settings/channels/new/whatsapp")}
      type="drawer"
      width={600}
      titleOverwrite={
        <span className="flex gap-3 items-center text-lg">
          <div className="size-7">{channelsDef.record["whatsapp"]?.icon}</div>
          Conectar WhatsApp
        </span>
      }
      successMessage="Canal de WhatsApp criado."
      stickyFooter
      onSubmitSuccess={() => {
        history.push("/settings/channels")
      }}
      okText="Conectar canal"
    >
      <StarAlert className="mt-2 mb-5 text-sm">
        <span>
          <a
            href="https:kinbox.notion.site/Instala-o-996c0c3974134465ac1a7f239c8f8c0b"
            target="_blank"
            rel="noreferrer"
            className="font-semibold underline"
          >
            {/* <i className="fal fa-lightbulb" style={{ marginRight: 5 }} /> */}
            Clique aqui
          </a>
          {` `}para ver a documentação de como conectar o WhatsApp Cloud API Oficial.
        </span>
      </StarAlert>

      {content}
    </FormModal>
  )
  // }

  // return (
  //   <>
  //     <Form layout="vertical" form={form} onFinish={onSubmit}>
  //       {/* <Card className={isAldeia ? "mx-auto max-w-lg" : "gray"}> */}
  //       <Card className={isAldeia ? "p-6 shadow-none border-separator-active" : "gray"}>{content}</Card>
  //       <br />
  //       <Row>
  //         <Button type="primary" htmlType="submit" loading={saving}>
  //           Criar canal
  //         </Button>
  //       </Row>
  //     </Form>
  //   </>
  // )
}

export default AddWhatsappCloud
